module.exports = __webpack_public_path__ + "img/vaade.831c6995.webp";